"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTheme = exports.default = void 0;
var _styles = require("@mui/material/styles");
var _tokens = require("../tokens");
var _Alert = require("../../Alert/Alert");
var _Button = require("../../Button/Button");
var _Checkbox = require("../../Checkbox/Checkbox");
var _Chip = require("../../Chip/Chip");
var _Selector = require("../../Selector/Selector");
var _Link = require("../../Link/Link");
var _Radio = require("../../Radio/Radio");
var _Select = require("../../Select/Select");
var _SvgIcon = require("../../SvgIcon/SvgIcon");
var _Switch = require("../../Switch/Switch");
var _TextField = require("../../TextField/TextField");
var _ToggleButton = require("../../ToggleButton/ToggleButton");
var _Typography = require("../../Typography/Typography");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var bluesPaletteTokens = {
  100: '#000B1F',
  90: '#001946',
  80: '#00266C',
  70: '#00338D',
  60: '#0044AC',
  50: '#115DC4',
  40: '#2E76CF',
  30: '#5196E5',
  20: '#80B6F0',
  10: '#B6D6F7',
  5: '#D3E6FA',
  0: '#F2F9FF'
};
var componentOverrides = {
  components: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _Alert.alertOverrides), _Button.buttonOverrides), _Checkbox.checkboxOverrides), _Selector.formControlLabelOverrides), _Link.linkOverrides), _Radio.radioOverrides), _Select.selectOverrides), _SvgIcon.svgIconOverrides), _Switch.switchOverrides), _TextField.textFieldOverrides), _ToggleButton.toggleButtonOverrides), _Typography.typographyOverrides), _Chip.chipOverrides)
};
var overlays = function overlays(theme) {
  theme.palette.overlay = {
    black: {
      5: (0, _styles.alpha)(theme.palette.common.black, 0.05),
      10: (0, _styles.alpha)(theme.palette.common.black, 0.1),
      15: (0, _styles.alpha)(theme.palette.common.black, 0.15),
      20: (0, _styles.alpha)(theme.palette.common.black, 0.2)
    },
    white: {
      75: (0, _styles.alpha)(theme.palette.common.white, 0.75),
      90: (0, _styles.alpha)(theme.palette.common.white, 0.9)
    },
    red: {
      10: (0, _styles.alpha)(theme.palette.error.dark, 0.1),
      15: (0, _styles.alpha)(theme.palette.error.dark, 0.15)
    },
    blue: {
      10: (0, _styles.alpha)(theme.palette.info.dark, 0.1)
    }
  };
  return theme;
};
var responsiveFontSizes = function responsiveFontSizes(theme) {
  theme.typography = _objectSpread(_objectSpread({}, theme.typography), {}, {
    d1: _objectSpread(_objectSpread({}, theme.typography.d1), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.d1.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(69),
      lineHeight: 88 / 69,
      letterSpacing: 1.2
    })),
    d2: _objectSpread(_objectSpread({}, theme.typography.d2), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.d2.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: 54,
      lineHeight: 72 / 54,
      letterSpacing: 1.2
    })),
    h1: _objectSpread(_objectSpread({}, theme.typography.h1), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.h1.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(44),
      lineHeight: 56 / 44,
      letterSpacing: 0.5
    })),
    h2: _objectSpread(_objectSpread({}, theme.typography.h2), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.h2.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(35),
      lineHeight: 48 / 35,
      letterSpacing: 0.5
    })),
    h3: _objectSpread(_objectSpread({}, theme.typography.h3), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.h3.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(28),
      lineHeight: 40 / 28,
      letterSpacing: 0.5
    })),
    h4: _objectSpread(_objectSpread({}, theme.typography.h4), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.h4.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(23),
      lineHeight: 32 / 23,
      letterSpacing: 0.5
    })),
    lead: _objectSpread(_objectSpread({}, theme.typography.lead), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.lead.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(23),
      lineHeight: 32 / 23,
      letterSpacing: 0.5
    })),
    blockquote: _objectSpread(_objectSpread({}, theme.typography.blockquote), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.blockquote.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(23),
      lineHeight: 32 / 23,
      letterSpacing: 0.5
    })),
    action: _objectSpread(_objectSpread({}, theme.typography.action), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.action.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 24 / 18,
      letterSpacing: 0.5
    })),
    actionBold: _objectSpread(_objectSpread({}, theme.typography.actionBold), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.actionBold.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 24 / 18,
      letterSpacing: 0.5
    })),
    bodyLarge: _objectSpread(_objectSpread({}, theme.typography.bodyLarge), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.bodyLarge.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(18),
      lineHeight: 24 / 18,
      letterSpacing: 0.4
    })),
    bodySmall: _objectSpread(_objectSpread({}, theme.typography.bodyLarge), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.bodySmall.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 24 / 16,
      letterSpacing: 0.4
    })),
    footnote: _objectSpread(_objectSpread({}, theme.typography.footnote), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.footnote.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: 24 / 16,
      letterSpacing: 0.3
    })),
    pretitle: _objectSpread(_objectSpread({}, theme.typography.pretitle), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.pretitle.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    })),
    label: _objectSpread(_objectSpread({}, theme.typography.label), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.label.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    })),
    labelBold: _objectSpread(_objectSpread({}, theme.typography.labelBold), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.labelBold.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(14),
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    })),
    option: _objectSpread(_objectSpread({}, theme.typography.option), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.option.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: theme.typography.pxToRem(14),
      fontStyle: 'italic',
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    })),
    caption: _objectSpread(_objectSpread({}, theme.typography.caption), {}, _defineProperty({
      fontSize: theme.typography.pxToRem(theme.typography.caption.fontSize)
    }, theme.breakpoints.up('tablet'), {
      fontSize: 12,
      lineHeight: 16 / 12,
      letterSpacing: 0.2
    }))
  });
  return theme;
};
var customActions = function customActions(theme) {
  var _theme$boxShadow = theme.boxShadow,
    outline = _theme$boxShadow.outline,
    underline = _theme$boxShadow.underline;
  var disabled = theme.palette.action.disabled;
  theme.palette.action = _objectSpread(_objectSpread({}, theme.palette.action), {}, {
    // Custom interactions
    outlineOpacity: 0.4,
    // default
    defaultOutline: "".concat(outline.default, " rgb(0 0 0 / 0.4)"),
    // applied to all things that can be interacted with.
    defaultUnderline: "".concat(underline.default, " rgb(0 0 0 / 0.4)"),
    // applied to all things that can be interacted with.

    // hover
    nonSelectableHoverOutline: outline.active,
    // applied to buttons
    selectableHoverOutline: outline.default,
    // applied to textfields, checkboxs
    selectableHoverUnderline: underline.default,
    // applied to textfields, checkboxs

    // focus / selected / error
    focusOutline: outline.active,
    // applied to all things that can be interacted with.
    focusUnderline: underline.active,
    // applied to all things that can be interacted with.
    selectedOutline: outline.active,
    // applied to Selectors

    // disable
    disabledOutline: "".concat(outline.default, " ").concat(disabled),
    disabledUnderline: "".concat(underline.default, " ").concat(disabled)
  });
  return theme;
};
var defaultTheme = {
  borders: {
    none: _tokens.borders.Borders['No Border'].size,
    small: _tokens.borders.Borders['thickness-s'].size,
    medium: _tokens.borders.Borders['thickness-m'].size,
    large: _tokens.borders.Borders['thickness-l'].size
  },
  boxShadow: {
    outline: {
      active: 'inset 0px 0px 0px 2px',
      default: 'inset 0px 0px 0px 1px'
    },
    underline: {
      active: 'inset 0px -2px 0px',
      default: 'inset 0px -1px 0px'
    }
  },
  opacity: {
    chipDeleteIcon: 0.26,
    chipDeleteIconHover: 0.4,
    inputPlaceholder: 0.5,
    inputUnderline: 0.5,
    switchTrack: 0.5,
    switchTrackDisabled: 0.2
  },
  palette: {
    text: {
      primary: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value,
      disabled: _tokens.colors.colors['Greys']['Grey 50'].value
    },
    action: {
      disabled: _tokens.colors.colors['Greys']['Grey 10'].value,
      disabledBackground: _tokens.colors.colors['Greys']['Grey 30'].value,
      hoverOpacity: 0.05,
      activatedOpacity: 0.1
    },
    common: {
      black: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value,
      white: _tokens.colors.colors['AAA | Neutrals']['White'].value
    },
    grey: {
      50: _tokens.colors.colors['Greys']['Grey 5'].value,
      // #F7F8FC
      100: _tokens.colors.colors['Greys']['Grey 10'].value,
      // #E3E5EE
      200: _tokens.colors.colors['Greys']['Grey 20'].value,
      // #CFD2E0
      300: _tokens.colors.colors['Greys']['Grey 30'].value,
      // #ABAFBF
      400: _tokens.colors.colors['Greys']['Grey 40'].value,
      // #878C9D
      500: _tokens.colors.colors['Greys']['Grey 50'].value,
      // #676C7D
      600: _tokens.colors.colors['Greys']['Grey 60'].value,
      // #4D5160
      700: _tokens.colors.colors['Greys']['Grey 70'].value,
      // #373B49
      800: _tokens.colors.colors['Greys']['Grey 80'].value,
      // #262A37
      900: _tokens.colors.colors['Greys']['Grey 90'].value,
      // #191E2B
      1000: _tokens.colors.colors['Greys']['Grey 100'].value // #0B1421
    },

    primary: {
      main: bluesPaletteTokens[50],
      // #115DC4
      light: bluesPaletteTokens[20],
      // #80B6F0
      dark: bluesPaletteTokens[60],
      // #0044AC
      darker: bluesPaletteTokens[70] // #00338D
    },

    secondary: {
      main: _tokens.colors.colors['Greys']['Grey 60'].value,
      light: _tokens.colors.colors['Blues']['Blue 40'].value,
      dark: _tokens.colors.colors['Blues']['Blue 70'].value
    },
    error: {
      main: '#D52B1E',
      light: '#FEB3B3',
      lighter: '#FFE6E6',
      dark: '#D52B1E',
      contrastText: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value
    },
    warning: {
      main: '#FFF3B3',
      light: '#FFEC85',
      lighter: '#FFFAE0',
      dark: '#EBA62F',
      contrastText: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value
    },
    info: {
      main: bluesPaletteTokens[5],
      // #D3E6FA
      light: '#B6D6F7',
      lighter: bluesPaletteTokens[0],
      // #F2F9FF
      dark: bluesPaletteTokens[50],
      // #115DC4
      contrastText: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value
    },
    success: {
      main: '#00844D',
      light: '#B3F9CE',
      lighter: '#F2FFF7',
      dark: '#00844D',
      contrastText: _tokens.colors.colors['AAA | Neutrals']['AAA / Neutral / Black'].value
    }
  },
  shape: {
    borderRadius: 4
  },
  spacing: 8,
  typography: {
    fontFamily: ['Slash', 'RT Raleway', 'Raleway', 'Work Sans', 'Cabin', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    h5: undefined,
    h6: undefined,
    subtitle1: undefined,
    subtitle2: undefined,
    body1: undefined,
    body2: undefined,
    button: undefined,
    overline: undefined,
    d1: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 47,
      lineHeight: 56 / 47,
      letterSpacing: 0.5
    },
    d2: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 39,
      lineHeight: 48 / 39,
      letterSpacing: 0.5
    },
    h1: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 33,
      lineHeight: 48 / 33,
      letterSpacing: 0.5
    },
    h2: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 27,
      lineHeight: 40 / 27,
      letterSpacing: 0.5
    },
    h3: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 23,
      lineHeight: 32 / 23,
      letterSpacing: 0.5
    },
    h4: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 19,
      lineHeight: 24 / 19,
      letterSpacing: 0.5
    },
    lead: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 19,
      lineHeight: 24 / 19,
      letterSpacing: 0.5
    },
    blockquote: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 19,
      lineHeight: 24 / 19,
      letterSpacing: 0.5
    },
    action: {
      fontFamily: 'RT Raleway',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 24 / 16,
      letterSpacing: 0.4
    },
    actionBold: {
      fontFamily: 'RT Raleway',
      fontWeight: 700,
      fontSize: 16,
      lineHeight: 24 / 16,
      letterSpacing: 0.4
    },
    bodyLarge: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 24 / 16,
      letterSpacing: 0.3
    },
    bodySmall: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 16,
      lineHeight: 24 / 16,
      letterSpacing: 0.3
    },
    footnote: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 24 / 14,
      letterSpacing: 0.2
    },
    pretitle: {
      fontFamily: 'Cabin',
      fontWeight: 500,
      fontSize: 14,
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    },
    label: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 14,
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    },
    labelBold: {
      fontFamily: 'Cabin',
      fontWeight: 700,
      fontSize: 14,
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    },
    option: {
      fontFamily: 'Cabin',
      fontWeight: 700,
      fontSize: 14,
      fontStyle: 'italic',
      lineHeight: 16 / 14,
      letterSpacing: 0.2
    },
    caption: {
      fontFamily: 'Cabin',
      fontWeight: 400,
      fontSize: 10,
      lineHeight: 16 / 10,
      letterSpacing: 0.2
    }
  },
  breakpoints: {
    values: {
      mobile: 0,
      tablet: 640,
      desktop: 1040
    }
  }
};
exports.defaultTheme = defaultTheme;
var createTheme = function createTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var themeOptions = _objectSpread(_objectSpread(_objectSpread({}, options), defaultTheme), componentOverrides);
  var theme = (0, _styles.createTheme)(themeOptions);
  return overlays(customActions(responsiveFontSizes(theme)));
};
var _default = createTheme;
exports.default = _default;